<template>
  <span
    :class="[
      'text-md',
      {
        'text-green-400': value > 0,
        'text-red-400': value < 0,
        'text-gray-400': value === 0,
      },
    ]"
  >
    {{ textBefore }}
    <span
      :class="[
        'inline-block transform',
        {
          '-rotate-90': value > 0,
          'rotate-90': value < 0,
        },
      ]"
    >
      {{ value === 0 ? "━" : "➜" }}
    </span>
    {{ textAfter }}
  </span>
</template>

<script>

export default {
  name: "TrendArrow",
  props: {
    value: Number,
    textBefore: String,
    textAfter: String,
  },
};
</script>
